import { render } from "./CustomerView.vue?vue&type=template&id=08aff13d&scoped=true"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"

import "./CustomerView.vue?vue&type=style&index=0&id=08aff13d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aff13d"]])

export default __exports__